import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import weekDay from 'dayjs/plugin/weekday'
import relativeTime from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
import i18next, { i18n as i18nType } from 'i18next'

const initDayjsLocales = (lang: string) => {
	// const lang = 'zh'
	if (!lang) return
	import(`dayjs/locale/${lang}`)
	dayjs.locale(lang)
	dayjs.extend(weekDay)
	dayjs.extend(LocalizedFormat)
	dayjs.extend(customParseFormat)
	dayjs.extend(relativeTime)
	dayjs.extend(isBetween)
}
export const initDayjs = (instance?: i18nType) => {
	;(instance || i18next).on('languageChanged', initDayjsLocales)
}
